import styled from 'styled-components';

export const ContainerConfirmSchedule = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: #f5f7fa;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;

  @media (max-width: 768px) {
    padding: 8px;
    align-items: flex-start;
    padding-top: 20px;
  }
`;

export const ScheduleDetailsCard = styled.div`
  display: grid;
  gap: 12px;
  margin-bottom: 0;

  @media (max-width: 768px) {
    gap: 8px;
  }

  .detail-section {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 6px;
    border-left: 3px solid #1890ff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      padding: 10px;
      border-left-width: 2px;
    }

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
    }

    h3 {
      margin: 0 0 6px 0;
      font-size: 12px;
      font-weight: 600;
      color: #1890ff;
      text-transform: uppercase;
      letter-spacing: 0.5px;

      @media (max-width: 768px) {
        font-size: 11px;
        margin-bottom: 4px;
      }
    }

    p {
      margin: 0;
      color: #262626;
      font-size: 14px;
      line-height: 1.4;

      @media (max-width: 768px) {
        font-size: 13px;
        line-height: 1.3;
      }
    }
  }
`;

export const SuccessMessage = styled.div`
  padding: 16px;
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  border-left: 4px solid #52c41a;
  border-radius: 4px;
  color: #52c41a;
  margin-bottom: 20px;
`;

export const ErrorMessage = styled.div`
  padding: 16px;
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  border-left: 4px solid #ff4d4f;
  border-radius: 4px;
  color: #ff4d4f;
  margin-bottom: 20px;
`;
